// Menu 관련 유틸리티
import constants    from '@/constants';
import store        from '@/vuex/store';
import SDLUtil      from '@/utils/SDLUtil';
import StringUtil   from '@/utils/StringUtil';
/**
 * param: menuId, menus, queue, menuObj
 * return: menu
 */
const menuScan = (menuId, menus = {}, queue = menus, menuObj = []) => {
    if(menuId === menus.menuId) {
        menuObj.push({
            depth : menus.menuLevel,
            menuId : menus.menuId,
            menuNm : menus.menuNm,
            menuPid : menus.menuPid || "",
            menuGrpCd : menus.menuGroupCd || "",
            menuGrpDetailCd: menus.menuGroupDetailCd || "",
            creationYn : menus.creationYn || "",
            connUrl : menus.connUrl || "",
            currMenu : true
        });
        
        return menuObj;

    } else if(queue.length === 0){
        return false;

    } else {
        menuObj.push({ depth : menus.menuLevel, menuId : menus.menuId, menuNm : menus.menuNm, menuPid : menus.menuPid || "", currMenu : false });
        return menuScan(menuId, queue[0], queue.slice(1).concat(queue[0].subMenu || []), menuObj);
    }
};

const menuScanByUrl = (menuUrl, menus = {}, queue = menus, menuObj = []) => {
    let menuParams = StringUtil.getAllUrlParams(menuUrl);
    let menuUri = menuUrl.split('?')[0];

    if((menus.connUrl || "").indexOf(menuUri) > -1) {
        let connParams = StringUtil.getAllUrlParams(menus.connUrl);
        if(menus.connUrl.indexOf('/knowledgeList.skp?BOARD_ID') > -1) {
            if(menuParams['board_id'] === connParams['board_id']) {
                menuObj.push({
                    depth : menus.menuLevel,
                    menuId : menus.menuId,
                    menuNm : menus.menuNm,
                    menuPid : menus.menuPid || "",
                    menuGrpCd : menus.menuGroupCd || "",
                    menuGrpDetailCd: menus.menuGroupDetailCd || "",
                    creationYn : menus.creationYn || "",
                    connUrl : menus.connUrl || "",
                    currMenu : true
                });
                
                return menuObj;

            } else if(queue.length === 0){
                return false;

            } else {
                menuObj.push({ depth : menus.menuLevel, menuId : menus.menuId, menuNm : menus.menuNm, menuPid : menus.menuPid || "", currMenu : false });
                return menuScanByUrl(menuUrl, queue[0], queue.slice(1).concat(queue[0].subMenu || []), menuObj);
            };

        } else {
            menuObj.push({
                depth : menus.menuLevel,
                menuId : menus.menuId,
                menuNm : menus.menuNm,
                menuPid : menus.menuPid || "",
                menuGrpCd : menus.menuGroupCd || "",
                menuGrpDetailCd: menus.menuGroupDetailCd || "",
                creationYn : menus.creationYn || "",
                connUrl : menus.connUrl || "",
                currMenu : true
            });
            
            return menuObj;
        };
        

    } else if(queue.length === 0){
        return false;

    } else {
        menuObj.push({ depth : menus.menuLevel, menuId : menus.menuId, menuNm : menus.menuNm, menuPid : menus.menuPid || "", currMenu : false });
        return menuScanByUrl(menuUrl, queue[0], queue.slice(1).concat(queue[0].subMenu || []), menuObj);
    };
};

const menuScanByUrlEx = (menuUrl, menus = {}, queue = menus, menuObj = []) => {
    let menuParams = StringUtil.getAllUrlParams(menuUrl);
    if(SDLUtil.nvl(menus.connUrl, '').replace('.skp', '') === menuUrl) {
        let connParams = StringUtil.getAllUrlParams(menus.connUrl);
        menuObj.push({
            depth : menus.menuLevel,
            menuId : menus.menuId,
            menuNm : menus.menuNm,
            menuPid : menus.menuPid || "",
            menuGrpCd : menus.menuGroupCd || "",
            menuGrpDetailCd: menus.menuGroupDetailCd || "",
            creationYn : menus.creationYn || "",
            connUrl : menus.connUrl || "",
            currMenu : true
        });
        
        return menuObj;

    } else if(queue.length === 0){
        return false;

    } else {
        menuObj.push({ depth : menus.menuLevel, menuId : menus.menuId, menuNm : menus.menuNm, menuPid : menus.menuPid || "", currMenu : false });
        return menuScanByUrlEx(menuUrl, queue[0], queue.slice(1).concat(queue[0].subMenu || []), menuObj);
    };
};

/**
 * return: Scrap work code
 */
const getScrapWorkCode = () => {
    let menuGrpCd = store.getters.getParams.menuGrpCd || '';
    let scrapWorkCd = "";
    switch ( menuGrpCd ) {
        case "PI":  // PRODUCT_INFOMATION_CD
            scrapWorkCd = `${constants.PRODUCT_INFOMATION_CD}`; break;

        case "PS":  // PRODUCT_SOFT_CD
            scrapWorkCd = `${constants.PRODUCT_SOFT_CD}`; break;

        case "QT":  // QUICK_TIPS_CD
            scrapWorkCd = `${constants.QUICK_TIPS_CD}`; break;

        case "RF":  // REFERENCE_KNOWLEDGE_CD
            scrapWorkCd = `${constants.REFERENCE_KNOWLEDGE_CD}`; break;

        case "TR":  // TRAINING__CD
            scrapWorkCd = `${constants.TRAINING__CD}`; break;

        case "SA":  // SALES_MARKETING_CD
            scrapWorkCd = `${constants.SALES_MARKETING_CD}`; break;

        default:  // OTHER_CD
            scrapWorkCd = `${constants.OTHER_CD}`; break;
    }

    return scrapWorkCd;
};

const getSupportMain = () => {
    const allMenus = store.getters.getMenus || [];
    for (const menus of allMenus) {
        for (const menu of menus.subMenu) {
            store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
            let connUrl = menu.connUrl.replace('.skp', '');
            return connUrl;
        }
    }
    // return '/basis/faq/faqList';
};

const getRedirectUrl = api => {
    // return `${SDLUtil.WEB_CONTEXT_PATH}/?r=` + api;
    return `${SDLUtil.WEB_CONTEXT_PATH}` + api;
};

/*
 * SKP 에서 사용하는 Admin Menu Id 모음
 */
const getAdminMenu = [
    'TOP_0000000010',
    'TOP_3000004855',
    'TOP_00000051837',
    'TOP_0000074799',
];

const getSymptomGroup = [
    'SB',   // Service Bulletin
    'KSBL', // Service Bulletin (Local)
    'RT',   // Repair Tip
    'KRTT', // Repair/Tech Tip
    'CG',   // Call Guide - not yet
    'RRT',  // Repeated Repair Tip - not yet
];

const getRepairMenuGroup = [
    'SB',   // Service Bulletin
    'KSBL', // Service Bulletin (Local)
    'RT',   // Repair Tip
    'KRTT', // Repair Tip (Local)
    'AT',   // Agent Tip
    'KAGT'  // Agent Tip (Local)
];

const getGuideDefectGroup = [
    'SB',   // Service Bulletin
    'KSBL'  // Service Bulletin (Local)
];

const getScmsContents = [
    'SB',   // Service Bulletin
    'RT',   // Repair Tip
];

// ↑↑↓↓←→←→BA
const getMoveKeyDownCode = "38,38,40,40,37,39,37,39,66,65";

export default {
    menuScan,
    menuScanByUrl,
    menuScanByUrlEx,
    getScrapWorkCode,
    getSupportMain,
    getRedirectUrl,
    getAdminMenu,
    getSymptomGroup,        // deprecated
    getRepairMenuGroup,
    getGuideDefectGroup,
    getScmsContents,
    getMoveKeyDownCode
};



// WEBPACK FOOTER //
// ./src/utils/MenuUtil.js